import { render, staticRenderFns } from "./DashboardPerizinan.vue?vue&type=template&id=543cd90d&"
import script from "./DashboardPerizinan.vue?vue&type=script&lang=js&"
export * from "./DashboardPerizinan.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPerizinan.vue?vue&type=style&index=0&id=543cd90d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports